import * as React from 'react';
import cxs from 'cxs';

const forms = [
  'M311.1,9.41c73.22,26.85,63.86,93.38,140,116,41.53,12.34,64.78-1.37,106,23,8.74,5.17,54.24,32.08,51,61-4.18,37.25-84,31.7-108,85-18.83,41.78,19.8,68.26,5,109-28,77.14-209.28,99.87-234,56-11.69-20.73,16.93-46.91,5-62-23.71-30-140.14,68.88-217,29-49.12-25.48-72.71-102.75-51-134,17.2-24.75,59.66-16,64-34,5.91-24.48-70.37-50.17-66-78,4-25.3,68.65-14.35,110-63,26.53-31.21,12.53-50.56,37-78C187.06,1.34,257.57-10.21,311.1,9.41Z',
  'M304,74.17c70.5,1.91,85.58-70.07,164-74,58.76-2.95,123.1,33.8,129,73,5.44,36.11-41.61,55.3-34,92,8.37,40.34,70.46,42.28,72,72,2,39.12-104.42,58.3-109,120-1.17,15.85,5.64,17.45,3,31-11.07,56.87-145.71,103-220,59-32.55-19.28-26.28-39.74-59-55-55.83-26.05-94.06,24.2-153,7C41.22,382.89-7.55,313.7,1,261.17c8.26-50.91,66.92-65.1,67-123,0-28.75-14.4-35.8-8-57,10.85-35.91,65.26-58.63,112-58C239.17,24.06,246.36,72.6,304,74.17Z',
  'M470.47,115.16c18.64,8.21,39.3-38.37,90-46,5.93-.89,48.87-7.36,67,15,32.51,40.09-52.93,125.78-16,189,11.44,19.58,24.25,20.25,30,41,9.37,33.87-18.12,73.47-42,95-53.76,48.44-148.68,48.1-206,10-37.33-24.81-33.73-44.34-60-49-63.67-11.28-108.76,106.63-179,95-1.28-.21-29.5-5.3-45-28-30-43.89,19.19-107.39-5-131-20.79-20.29-65.65,18.22-90-2-28-23.29-14.39-112.38,33-142,28.56-17.85,59.22-6.82,70-27,10.42-19.53-14.62-36.73-10-64,7.09-42,80.2-83,136-68,50.65,13.62,64.93,71.9,95,65,22-5,21.56-37.41,53-47,14.38-4.39,34.84-3.83,49,7C471.06,51.57,450.5,106.37,470.47,115.16Z',
  'M262,37.72c38.82-30.32,104.73-51.53,141-27,34.41,23.27,27.49,77.8,57,83,9.24,1.63,15.88-2.66,28-9,20.29-10.61,76.58-40,106-36,48.83,6.71,101.7,116.4,68,178-31.45,57.5-128.63,55.37-128,84,.48,22,57.78,22.64,71,63,9.46,28.88-8.37,63.72-29,83-23.47,21.93-52.16,25.21-60,26-98.34,9.89-153.41-116.73-217-98-32.11,9.46-23.31,43.3-66,74-67.28,48.39-185.21,33.44-205-12C8.6,402.17,96.47,358,82,284.72c-10.81-54.82-65.09-56.09-79-115-15.4-65.21,31.15-148.14,75-152,48.53-4.27,77,89.81,124,81C226.65,94.11,224.16,67.28,262,37.72Z',
]

export const HighlightForm: React.FC<{
  color: string,
  form: number,
  width: number
}> = props => {
  return (
    <svg
      viewBox={`0 0 ${props.width + 80} ${props.width * (488.62 / 672.65) + 50}`}
      className={cxs({
        position: 'absolute',
        top: 0,
        left: 0,
        width: props.width + 'px',
        '> path': {
          fill: props.color
        }
      })}
    >
      <path d={forms[props.form]} />
    </svg>
  );
};
